import { render, staticRenderFns } from "./PersonPayrollDirectAssignmentEdit.vue?vue&type=template&id=3b16575f"
import script from "./PersonPayrollDirectAssignmentEdit.vue?vue&type=script&lang=js"
export * from "./PersonPayrollDirectAssignmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports